import { useTranslate } from 'hooks/useTranslate';

import { getConsolidationPeriods } from 'utils/consolidationPeriods';

import BeneficiaryCalendarRow from 'modules/beneficiaries/components/BeneficiaryCalendarRow';
import { hasShowDetails } from 'utils/showDetails';

const CalendarTab = ({ beneficiary, plan }) => {
  const { t } = useTranslate();

  const periods = getConsolidationPeriods(beneficiary, plan);

  const rows = periods.map((period, index) => (
    <BeneficiaryCalendarRow
      period={period}
      index={index + 1}
      key={period?.date.toString()}
    />
  ));

  return (
    <div className="card-inner p-0">
      <h6>{t('ConsolidationCalendarOf')}</h6>

      {rows.length > 0 && (
        <div className="nk-block nk-block-lg pt-1">
          <div className="card card-bordered card-preview">
            <table
              className="table table-striped table-responsive"
              id="consolidationTable"
            >
              <thead>
                <tr>
                  <th scope="col" style={{ textAlign: 'center' }}>
                    {t('Nr')}
                  </th>
                  <th scope="col" style={{ textAlign: 'left' }}>
                    {t('Date')}
                  </th>
                  <th scope="col" style={{ textAlign: 'center' }}>
                    {t('UnitsSeen')}
                  </th>
                  <th scope="col" style={{ textAlign: 'center' }}>
                    {t('TotalUnitsVeiled')}
                  </th>
                  <th scope="col" style={{ textAlign: 'left' }}>
                    {t('Status')}
                  </th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarTab;
